import React, { FC } from 'react';
import { Connect, PropsFromRedux } from './AsideFiltersContainer';
import { ExactDateSelectors } from './dates/exact-selection/ExactDateSelectors';
import { Dates } from './dates/range-selection/Dates';
import { AsideFiltersCategory } from './AsideFiltersCategory';
import { Exclude } from './exclude/Exclude';
import { Parties } from './parties/Parties';
import styles from './aside_filters.module.scss';

export const RawAsideFilters: FC<PropsFromRedux> = ({
  shouldDisplayDate,
  shouldDisplayInForceDate,
  shouldDisplayVille,
  shouldDisplayJuridiction,
  shouldDisplayDomaine,
  shouldDisplayPubli,
  shouldDisplaySolution,
  shouldDisplayPublisher,
  shouldDisplayCommentaryAccess,
  shouldDisplayExclude,
  shouldDisplayParties,
  shouldDisplayTextCode,
  shouldDisplayCollectiveAgreements,
  shouldDisplayOtherLegislation,
  shouldDisplayPwCategory,
  shouldDisplayPwLegislativeFolder,
  search_type,
}) => {
  // For legacy continuity in tracking
  const adapted_type = search_type === 'arret' ? 'decision' : search_type;
  return (
    <div className={styles.container}>
      {shouldDisplayVille && <AsideFiltersCategory type="ville" />}
      {shouldDisplayDate && <Dates search_type={adapted_type} />}
      {shouldDisplayInForceDate && <ExactDateSelectors type={adapted_type} />}
      {shouldDisplayTextCode && <AsideFiltersCategory type="textCode" />}
      {shouldDisplayExclude && <Exclude />}
      {shouldDisplayJuridiction && <AsideFiltersCategory type="juridiction" />}
      {shouldDisplayDomaine && <AsideFiltersCategory type="domaine" />}
      {shouldDisplayPubli && <AsideFiltersCategory type="publi" />}
      {shouldDisplaySolution && <AsideFiltersCategory type="solution" />}
      {shouldDisplayPublisher && <AsideFiltersCategory type="publisher" />}
      {shouldDisplayCommentaryAccess && (
        <AsideFiltersCategory type="commentaryAccess" />
      )}
      {shouldDisplayPwCategory && <AsideFiltersCategory type="pwCategory" />}
      {shouldDisplayPwLegislativeFolder && (
        <AsideFiltersCategory type="pwLegislativeFolder" />
      )}
      {shouldDisplayParties && <Parties />}
      {shouldDisplayOtherLegislation && (
        <AsideFiltersCategory type="otherLegislation" />
      )}
      {shouldDisplayCollectiveAgreements && (
        <AsideFiltersCategory type="collectiveAgreements" />
      )}
    </div>
  );
};

export const AsideFilters = Connect(RawAsideFilters);
